
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.maxWidth = this.getBreakpointValue(this.blok?.maxWidth)

      return styles
    },
    outerStyles() {
      const styles = {}

      styles.paddingBottom = `calc(100% / calc(${this.getBreakpointValue(
        this.blok.aspectRatio
      )}))`

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      // media query context
      const mm = this.$gsap.matchMedia(this.$refs.navHeader) // scope to navHeader only

      // executes desktop only - lg breakpoint
      mm.add('(min-width: 1024px)', () => {
        this.initAnimation()
      })
    })
  },
  methods: {
    initAnimation() {
      this.$gsap.set(['.aspot-img'], {
        opacity: 0,
        scale: 0.9,
        transformOrigin: 'center center',
      })

      this.$gsap.to(['.aspot-img'], {
        opacity: 1,
        scale: 1,
        // y: 0,
        duration: 0.8,
        stagger: 0.3,
        delay: 0.3,
      })
    },
  },
}
